import cn from "classnames";

import LeftArrowIcon from "assets/icons/left-arrow.svg?react";
import RightArrowIcon from "assets/icons/right-arrow.svg?react";

import { MONTHS } from "./MonthPicker.constans";

import { Typography } from "shared/ui/components/Typography";

import styles from "./MonthPicker.module.scss";

const MonthPicker = ({
  className,
  year,
  selectedYear,
  month,
  onPreviousYearClick,
  onNextYearClick,
  onMonthClick,
}: any) => {
  return (
    <div className={cn(styles.monthPicker, className)}>
      <div className={styles.nav}>
        <Typography variant="bodyS" className={styles.year}>
          {year}
        </Typography>
        <div className={styles.iconWrapper} onClick={onPreviousYearClick}>
          <LeftArrowIcon className={styles.icon} />
        </div>
        <div className={styles.iconWrapper} onClick={onNextYearClick}>
          <RightArrowIcon className={styles.icon} />
        </div>
      </div>
      <div className={styles.months}>
        {MONTHS.map((monthItem, index) => (
          <div
            className={cn(styles.month, {
              [styles.monthSelected]:
                Number(selectedYear) === Number(year) &&
                Number(month) === index + 1,
            })}
            key={monthItem}
            onClick={() => onMonthClick(index + 1)}
          >
            <Typography variant="bodyS">{monthItem}</Typography>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MonthPicker;
